import { userStore } from '@/fsd/entities/user/model/store/useUserStore';

interface IParams {
  access: string;
  refresh: string;
}

export const saveTokens = ({ access, refresh }: IParams) => {
  localStorage.setItem('token', access);
  localStorage.setItem('refresh_token', refresh);
  if (access) {
    userStore.isLogged = true;
    userStore.token = access;
  }
};
